var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "allergy-kpis__row options-bar" }, [
    _c(
      "div",
      { staticClass: "allergy-kpis__filter" },
      [
        _c("StoreConnectedSelect", {
          attrs: { store: "allergyKpis", name: "year", options: _vm.yearsList }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "allergy-kpis__filter" },
      [
        _c("StoreConnectedSelect", {
          attrs: {
            store: "allergyKpis",
            name: "month",
            disabled: _vm.monthDisabled,
            options: _vm.monthsInReport
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }